"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Modal_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Modal"));
/**
 * Modals cannot have more than one child Header component. The content of this component contains all the header components.
 */
exports.Header = function (props) { return React.createElement(Modal_1.default.Header, props); };
exports.default = exports.Header;
